import { PageContainer, Card, Badge, Button } from '@aimsos/ui';
import { Plus, Edit, ShieldCheck } from 'lucide-react';

const ROLES = [
  {
    name: 'Admin',
    description: 'Full access to all platform features and settings.',
    users: 3,
    permissions: ['Manage Users', 'Manage Roles', 'View All', 'Edit All', 'Delete'],
    color: 'text-red-600 dark:text-red-400',
    bg: 'bg-red-50 dark:bg-red-900/20',
  },
  {
    name: 'Editor',
    description: 'Can create and edit content, but cannot manage users or roles.',
    users: 18,
    permissions: ['View All', 'Create', 'Edit All'],
    color: 'text-blue-600 dark:text-blue-400',
    bg: 'bg-blue-50 dark:bg-blue-900/20',
  },
  {
    name: 'Viewer',
    description: 'Read-only access to all platform content.',
    users: 52,
    permissions: ['View All'],
    color: 'text-green-600 dark:text-green-400',
    bg: 'bg-green-50 dark:bg-green-900/20',
  },
];

const Roles = () => (
  <PageContainer
    title="Roles & Permissions"
    actions={<Button leftIcon={Plus}>Create Role</Button>}
  >
    <div className="flex flex-col gap-4">
      {ROLES.map((role) => (
        <Card key={role.name}>
          <Card.Body>
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-4">
                <div className={['rounded-lg p-2.5', role.bg].join(' ')}>
                  <ShieldCheck size={22} className={role.color} />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-semibold text-content">{role.name}</h3>
                    <Badge variant="default">{role.users} users</Badge>
                  </div>
                  <p className="mt-0.5 text-sm text-content-muted">
                    {role.description}
                  </p>
                  <div className="mt-3 flex flex-wrap gap-1.5">
                    {role.permissions.map((perm) => (
                      <Badge key={perm} variant="primary">{perm}</Badge>
                    ))}
                  </div>
                </div>
              </div>
              <Button variant="ghost" size="sm" leftIcon={Edit}>Edit</Button>
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  </PageContainer>
);

export default Roles;
